import React from 'react';

import { DealerPanelContentHeadline } from '@/components/sections/dealer/panel/content/headline';
import { Divider } from '@/components/shared/element/divider';
import { Box } from '@/components/shared/layout/box';
import { Flex } from '@/components/shared/layout/flex';

interface DealerPanelContentGroupProps {
  headline?: string;
  children?: React.ReactNode;
}

export const DealerPanelContentGroup: React.FunctionComponent<
  DealerPanelContentGroupProps
> = (props: DealerPanelContentGroupProps) => {
  return (
    <Box className="dealer-group-item">
      {!!props.headline && (
        <DealerPanelContentHeadline label={props.headline} />
      )}
      <Flex direction="column" rowGap="4">
        {props.children}
      </Flex>
      <Divider css={{ marginTop: '$space-6' }} />
    </Box>
  );
};

DealerPanelContentGroup.displayName = 'SectionDealerPanelContentGroup';
